<template>
  <v-flex xs12 :style="baseStyle">
    <v-layout align-center justify-center>
      <v-flex xs12 lg11 xl9 px-2 pb-2>
        <v-img
          :src="badgeImage"
          alt="Badge"
          style="box-shadow: grey 4px 3px 10px;border-radius: 10px;">
          <v-layout row style="height:64%">
            <div class="left-side-card" style="width:33%" :style="userImage"/>
            <div v-if="fName && lName" >
              <v-layout column style="line-height: 1.1">
                <v-flex
                  v-text="fName"
                  :class="isLowResolution?'':'mt-2'"
                  class="first-name text-xs-left font-weight-bold pl-2"/>
                <v-flex
                  v-text="lName"
                  class="last-name text-xs-left font-weight-bold pl-2" />
              </v-layout>
            </div>
            <div
            v-else
            :class="isLowResolution?'':'pt-4'"
            class="first-name pl-2 font-weight-bold">
            <span v-text="fName && !lName ? fName: defaultName "/>
            </div>
          </v-layout>

        </v-img>
      </v-flex>
    </v-layout>

  </v-flex>
</template>
<script>
export default {
  name: 'UserCertificate',
  props: {
    appIcon: {},
    appName: {},
    appNameClass: {},
    defaultName: {},
    fName: {},
    lName: {},
    imageData: {}
  },
  data () {
    return {
      badgeImage: require('@/assets/images/template-badge.png')
    }
  },
  computed: {
    baseStyle () {
      let fontSize = '14px'
      if (this.appWidth < 350) {
        fontSize = '10px'
      } else if (this.appWidth < 380) {
        fontSize = '12px'
      }
      return {
        fontSize
      }
    },
    userImage () {
      const image = this.imageData ? this.imageData : require('@/assets/images/no-user.png')
      return {
        backgroundImage: 'url(' + image + ')',
        backgroundSize: 'cover'
      }
    },
    appWidth () {
      return this.$store.getters.getAppWidth
    },
    appHeight () {
      return this.$store.getters.getAppHeight
    },
    isLowResolution () {
      return this.appHeight < 600
    }
  }
}
</script>

<style scoped>
  .first-name, .last-name {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/sign-up/UserCertificate.vue